module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_D.2aea95dc.jpg";